import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface TokenState {
  token: string | null;
}

type SetToken = (token: string) => void;

const initialTokenState: TokenState = {
  token: null,
};

export const useTokenStore = create<TokenState & { setToken: SetToken }>()(
  devtools(
    persist(
      (set) => ({
        ...initialTokenState,
        setToken: (token: string) => {
          set((state) => ({
            ...state,
            token,
          }));
        },
      }),
      {
        name: 'token-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
);

// Hook to access setToken
export const useSetToken = () => useTokenStore((state) => state.setToken);

// Function to set token directly
export const setToken = (token: string) => {
  useTokenStore.setState({ token });
};

// Function to get token directly
export const getToken = () => {
  return useTokenStore.getState().token;
};

// Hook to access token
export const useToken = () => useTokenStore((state) => state.token);
